import { Component, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-without-fb-modal',
  templateUrl: './without-fb-modal.component.html',
  styleUrls: ['./without-fb-modal.component.css', '../../../assets/styles/table.css', '../../../assets/styles/panel.css','../../../assets/styles/text-title.css','../../../assets/styles/button.css','../../../assets/styles/body.css', '../../../assets/styles/dialog.css']
})
export class WithoutFbModalComponent implements OnInit {
  urlFacebook: string = "/api/facebook/without";
  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

}
